import React, { useCallback } from 'react'
import styled from '@emotion/styled'

// components
import { Label2 } from 'components/Labels'

// hooks
import { useColorScale } from 'flow/settings/color'
import { useHighlightedLegendItem } from 'flow/interactions/accessors'
import { css } from '@emotion/core'
const LegendColorContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 0 30px;
`

const LegendItemContainer = styled.div`
  height: 100%;
  flex: 1 1 0;
`

const LegendItem = styled(Label2)(({
  color,
  isHighlighted,
  isOneItemHighlighted,
  isAlignRight,
  label
}) => css`
  margin-right: 1px;
  min-height: 40px;
  opacity: ${isOneItemHighlighted && !isHighlighted ? 0.5 : 1};
  margin-top: 17px;
  border-top: 5px solid ${color};
  position: relative;
  &:after {
    content: '${label}';
    position: absolute;
    top: 7px;
    left: ${isAlignRight ? 'auto' : '0'};
    right: ${isAlignRight ? '0' : 'auto'};
    white-space: nowrap;
  }
`)

const Item = ({ onMouseEnter, onMouseLeave, d, highlightedId }) => {
  const onMouseEnterFn = useCallback(() => {
    onMouseEnter(d)
  }, [d, onMouseEnter])
  return (
    <LegendItemContainer
      onMouseEnter={onMouseEnterFn}
      onMouseLeave={onMouseLeave}
    >
      <LegendItem
        isAlignRight={d.isAlignRight}
        isHighlighted={highlightedId === d.id}
        isOneItemHighlighted={highlightedId}
        color={d.color}
        label={d.label}
      />
    </LegendItemContainer>

  )
}

const LegendColor = () => {
  const [colors, onMouseEnter, onMouseLeave] = useColorScale()
  const [highlightedLegendItem] = useHighlightedLegendItem()

  return (
    <LegendColorContainer>
      {
        colors.map((d, i) => (
          <Item
            d={d}
            key={d.id}
            highlightedId={highlightedLegendItem.id}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        ))
      }
    </LegendColorContainer>
  )
}

export default LegendColor
